import { Controller } from 'stimulus'
import SlimSelect from 'slim-select'

export default class extends Controller {
  static values = { selected: Number }

  connect() {
    this.selectId = this.element.dataset.ssid
    this.element[this.identifier] = this
    this.reset()
    this.render()
  }

  reset() {
    if (typeof this.selectId == 'undefined') return

    const slimSelect = document.querySelector(`.select.${this.selectId}`);

    if (!slimSelect) return

    slimSelect.remove()
    this.element.removeAttribute('style')
  }

  render() {
    this.slim = new SlimSelect({
      select: `#${this.element.getAttribute('id')}`,
      placeholder: this.element.getAttribute('placeholder'),
      showSearch: this.element.querySelectorAll('option').length > 10,
      searchPlaceholder: this.element.dataset.search,
      showContent: 'down',
      valuesUseText: false,
      data:
          this.element.querySelectorAll('optgroup').length > 0
          ? Array.from(this.element.querySelectorAll('optgroup')).map (opt => (
            {
              label: opt.getAttribute('label'),
              options: Array.from(opt.querySelectorAll('option')).map ( option => this.optionHTML(option))
            }
          ))
          : Array.from(this.element.querySelectorAll('option')).map (option => this.optionHTML(option))
    })
  }

  setData(data) {
    const formattedData = data.map (opt => (
      Array.isArray(opt)
      ?
        {
          label: opt[0],
          options: opt[1].map ( option => (
            {
              innerHTML: `<div class="flex items-baseline justify-between"><span class="main mr-2">${option[0]}</span><span class="info">${option[2]['data-info'] || ''}</span></div>`,
              text: `${option[0]} ${option[2]['data-info'] || ''}`,
              value: option[1],
              data: { info: option[2]['data-info'], opt: option[2]['data-opt'] },
              selected: false
            }
          ))
        }
      : this.optionHTML(opt)
    ))
    this.slim.setData(formattedData)
  }

  optionHTML(option) {
    return {
      innerHTML: `<div class="flex items-baseline justify-between"><span class="main mr-2">${option.textContent}</span><span class="info">${option.dataset.info || ''}</span></div>`,
      text: `${option.textContent} ${option.dataset.info || ''}`,
      value: option.getAttribute('value'),
      data: option.dataset,
      selected: option.getAttribute('value') == this.selectedValue
    }
  }
}
